import { mapEnumToOptions } from '@abp/ng.core';

export enum SupportVideoType {
  StudentSupport = 'StudentSupport',
  PartnerSupport = 'PartnerSupport',
}

export const supportVideoTypeOptions = mapEnumToOptions(SupportVideoType);
